import React, { useContext } from 'react'
import { bool } from 'prop-types'
import styled, { css } from 'styled-components'
import { navigate } from 'gatsby'

import { CANADIAN_PROVINCES } from 'utils/constants'

import NativeAuthContext from 'components/NativeAuth'
import Dropdown from 'components/Dropdown'
import * as spacing from 'styles/spacing'
import { media } from 'styles/media'

const Container = styled.div`
  margin-left: ${spacing.large};
  margin-top: ${spacing.small};
  min-width: 100px;

  ${media.medium`
    margin-top: 0;
    margin-left: 0;
    margin-right: ${spacing.small};
    min-width: 90px;

    ${props =>
      props.noMargin &&
      css`
        margin-right: 0 !important;
      `}
  `};

  ${media.large`
    margin-right: ${spacing.medium};
  `};
`

const ProvinceSelector = ({ transparent, noMargin }) => {
  const { user, province } = useContext(NativeAuthContext)

  if (user) return null

  return (
    <Container noMargin={noMargin}>
      <Dropdown
        inNav
        transparent={transparent}
        name="province"
        value={province}
        options={CANADIAN_PROVINCES.filter(p => p.value !== 'QC').map(c => ({ label: c.value, value: c.value }))}
        onChange={e => {
          const province = e.target.value
          navigate(
            `/soft-verify?redirectTo=${btoa(location.pathname + location.search)}&defaultSelectedProvince=${province}`
          )
        }}
      />
    </Container>
  )
}

ProvinceSelector.propTypes = {
  transparent: bool
}

export default ProvinceSelector
